import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import {
  Box,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody
} from '@mui/material'
import ModalLayout from '../layouts/ModalLayout'
import { modalSecondaryButtonStyle } from '../styles/buttonStyles'
import NetImage from '../assets/images/net.png'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import VOPModal from './VOPModal'
import { fetchWithAuth } from '../utils/fetchWithAuth'

export default function InfoModal({ open, onClose }) {
  const { t, i18n } = useTranslation()

  const [expandedIntro, setExpandedIntro] = useState(true)
  const [expanded1, setExpanded1] = useState(true)
  const [expanded2, setExpanded2] = useState(true)
  const [expandedBonus, setExpandedBonus] = useState(true)
  const [expandedCalc, setExpandedCalc] = useState(true)
  const [expandedReturn, setExpandedReturn] = useState(true)

  const [openVopModal, setOpenVopModal] = useState(false)

  const [pressedBtn, setPressedBtn] = useState(null)
  const [hoverBtn, setHoverBtn] = useState(null)

  const infoData = t('INFOPAGE', { returnObjects: true }) || {}

const [networkBonusLines, setNetworkBonusLines] = useState(null)
const [membershipList, setMembershipList] = useState([])

useEffect(() => {
  if (!open) return

  let isMounted = true

  const loadMlmBonuses = async () => {
      try {
        const res = await fetchWithAuth('/membership/types')
        const data = await res.json()

        if (!Array.isArray(data)) return

const formatNumber = (value, decimals = 2) =>
  Number(value || 0).toFixed(decimals).replace('.', ',')

const generatedMemberships = data
  .sort((a, b) => a.id - b.id)
  .map((item) => {
    const unit = item.is_electric ? 'kWh' : 'l'
    const bonusDecimals = item.is_electric ? 3 : 2

    return {
      type: item.type,
      price: formatNumber(item.price, 0),
      duration: item.duration_months,
      bonus: formatNumber(item.discount_per_unit, bonusDecimals),
      unit,
      maxCashback: formatNumber(item.max_cashback)
    }
  })

setMembershipList(generatedMemberships)

        const fuelType = data.find((item) => item && item.is_electric === false)
        const electricType = data.find((item) => item && item.is_electric === true)

        const fuelLevels = Array.isArray(fuelType?.mlm_bonus_levels)
          ? fuelType.mlm_bonus_levels
          : []

        const electricLevels = Array.isArray(electricType?.mlm_bonus_levels)
          ? electricType.mlm_bonus_levels
          : []

        const formatRate = (value) =>
          Number(value || 0).toString().replace('.', ',')

const fuelLines = fuelLevels.map(
  (lvl) =>
    t('INFOPAGE.NETWORK_FUEL_LEVEL', {
      level: lvl.level,
      count: lvl.max_count,
      bonus: formatRate(lvl.bonus_per_unit)
    })
)

const electricLines = electricLevels.map(
  (lvl) =>
    t('INFOPAGE.NETWORK_ELECTRIC_LEVEL', {
      level: lvl.level,
      count: lvl.max_count,
      bonus: formatRate(lvl.bonus_per_unit)
    })
)

        if (isMounted && (fuelLines.length || electricLines.length)) {
          setNetworkBonusLines([
            ...fuelLines,
            ...electricLines,
            infoData.DISCOUNTS_LIST?.[6],
            infoData.DISCOUNTS_LIST?.[7]
          ].filter(Boolean))
        }
      } catch (_) {
      }
    }

    loadMlmBonuses()

    return () => {
      isMounted = false
    }

// eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open, i18n.language])

  const discountsList = networkBonusLines || infoData.DISCOUNTS_LIST || []

  if (!open) return null

  const scrollSummaryToTop = (id) => {
    const container = document.getElementById('infoModalScroll')
    const summary = document.getElementById(`accsum-${id}`)
    if (!container || !summary) return

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        const containerRect = container.getBoundingClientRect()
        const summaryRect = summary.getBoundingClientRect()
        const top = container.scrollTop + (summaryRect.top - containerRect.top)
        container.scrollTo({ top, behavior: 'smooth' })
      })
    })
  }

  const renderAccordionHeaderButton = (id, expanded, setExpanded, label) => (
    <AccordionSummary
      id={`accsum-${id}`}
      onClick={() => {
        const next = !expanded
        setExpanded(next)
        if (next) scrollSummaryToTop(id)
      }}
      onMouseEnter={() => setHoverBtn(id)}
      onMouseLeave={() => {
        setHoverBtn(null)
        setPressedBtn(null)
      }}
      onMouseDown={() => setPressedBtn(id)}
      onMouseUp={() => setPressedBtn(null)}
      sx={{
        padding: 0,
        minHeight: 'auto',
        '&.Mui-expanded': { minHeight: 'auto' },
        '& .MuiAccordionSummary-content': { margin: 0 },
        '& .MuiAccordionSummary-content.Mui-expanded': { margin: 0 }
      }}
    >
      <Box
        sx={{
          ...modalSecondaryButtonStyle(pressedBtn, id, hoverBtn === id),
          width: '100%',
          background: '#1e3f44',
          color: '#fff',
          fontWeight: expanded ? 900 : 600,
          borderRadius: 2,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          padding: '12px 16px'
        }}
      >
        {label}
        <ExpandMoreIcon
          sx={{
            transition: 'transform 0.2s',
            transform: expanded ? 'rotate(180deg)' : 'rotate(0deg)'
          }}
        />
      </Box>
    </AccordionSummary>
  )

  return (
    <>
      <ModalLayout open={open} onClose={openVopModal ? () => {} : onClose} size="large" zIndex={4000}>
        <Box id="infoModalScroll" sx={{ overflowY: 'auto', flex: 1, pr: 1 }}>

          <h3 style={{ fontSize: 24, marginTop: 5, marginBottom: 20 }}>
            {infoData.TITLE}
          </h3>

          <Typography sx={{ mb: 2 }}>{infoData.INTRO1}</Typography>

          <Accordion expanded={expandedIntro} sx={{ mt: 2, borderRadius: 2, overflow: 'hidden', '&:before': { display: 'none' } }}>
            {renderAccordionHeaderButton('application', expandedIntro, setExpandedIntro, infoData.APPLICATION_TITLE)}
            <AccordionDetails>
              {infoData.APPLICATION_LIST?.map((section, i) => (
                <Box key={i} sx={{ mb: 2 }}>
                  <Typography sx={{ fontWeight: 'bold' }}>{section.title}</Typography>
                  {section.items?.map((item, j) => (
                    <Typography key={j}>• {item}</Typography>
                  ))}
                </Box>
              ))}

              <Typography sx={{ fontWeight: 'bold', mt: 2 }}>
                {infoData.APPLICATION_PLANNED_TITLE}
              </Typography>

              {infoData.APPLICATION_PLANNED_LIST?.map((section, i) => (
                <Box key={i} sx={{ mb: 2 }}>
                  <Typography sx={{ fontWeight: 'bold' }}>{section.title}</Typography>
                  {section.items?.map((item, j) => (
                    <Typography key={j}>• {item}</Typography>
                  ))}
                </Box>
              ))}
            </AccordionDetails>
          </Accordion>

          <Typography sx={{ mt: 2 }}>{infoData.INTRO2}</Typography>
          <Typography sx={{ mt: 2 }}>{infoData.INTRO3}</Typography>
          <Typography sx={{ mt: 2 }}>{infoData.REFERRAL_INFO}</Typography>
          <Typography sx={{ mt: 2 }}>{infoData.NETWORK_INFO}</Typography>

          <Accordion expanded={expanded2} sx={{ mt: 2, borderRadius: 2, overflow: 'hidden', '&:before': { display: 'none' } }}>
            {renderAccordionHeaderButton('discounts', expanded2, setExpanded2, infoData.DISCOUNTS_TITLE)}
            <AccordionDetails>
              {discountsList.map((line, i) => (
                <Typography key={i}>{line}</Typography>
              ))}

              <Box sx={{ mt: 2 }}>
                <img src={NetImage} alt="network" style={{ width: '100%' }} />
              </Box>
            </AccordionDetails>
          </Accordion>

          <Typography sx={{ mt: 2 }}>{infoData.CASHBACK_INFO}</Typography>
          <Typography sx={{ mt: 2 }}>{infoData.INTRO4}</Typography>

          <Accordion expanded={expanded1} sx={{ mt: 2, borderRadius: 2, overflow: 'hidden', '&:before': { display: 'none' } }}>
            {renderAccordionHeaderButton('membership', expanded1, setExpanded1, infoData.MEMBERSHIP_TITLE)}
            <AccordionDetails>
              {(membershipList.length
  ? membershipList.map((membership) => ({
      title: t('INFOPAGE.MEMBERSHIP_ITEM_TITLE', membership),
      desc: t('INFOPAGE.MEMBERSHIP_ITEM_DESCRIPTION', membership)
    }))
  : infoData.MEMBERSHIP_LIST
)?.map((item, i) => (
                <Box key={i} sx={{ mb: 2 }}>
                  <Typography sx={{ fontWeight: 'bold' }}>{item.title}</Typography>
                  <Typography>{item.desc}</Typography>
                </Box>
              ))}

              <Typography>{infoData.MEMBERSHIP_NOTE}</Typography>

              <Typography sx={{ fontWeight: 'bold', mt: 1 }}>
                {infoData.MEMBERSHIP_NOTE_BOLD}
              </Typography>
            </AccordionDetails>
          </Accordion>

          <Accordion expanded={expandedBonus} sx={{ mt: 2, borderRadius: 2, overflow: 'hidden', '&:before': { display: 'none' } }}>
            {renderAccordionHeaderButton('bonus', expandedBonus, setExpandedBonus, infoData.BONUS_TITLE)}
            <AccordionDetails>
              <Typography sx={{ mb: 2 }}>{infoData.BONUS_INTRO}</Typography>

              {infoData.BONUS_TABLE && (
                <Table size="small">
                  <TableHead>
                    <TableRow>
                      {infoData.BONUS_TABLE.HEADER.map((h, i) => (
                        <TableCell key={i}>
                          <strong>{h}</strong>
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {infoData.BONUS_TABLE.ROWS.map((row, i) => (
                      <TableRow key={i}>
                        {row.map((cell, j) => (
                          <TableCell key={j}>{cell}</TableCell>
                        ))}
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              )}

              <Typography sx={{ mt: 2 }}>{infoData.BONUS_NOTE}</Typography>

              <Typography sx={{ fontWeight: 'bold', mt: 2 }}>
                {infoData.BONUS_EXAMPLE_TITLE}
              </Typography>

              {infoData.BONUS_EXAMPLE_ROWS?.map((row, i) => (
                <Typography key={i}>
                  {row.join('  ')}
                </Typography>
              ))}

              <Typography sx={{ mt: 1 }}>
                {infoData.BONUS_EXAMPLE_NOTE}
              </Typography>
            </AccordionDetails>
          </Accordion>

          <Accordion expanded={expandedCalc} sx={{ mt: 2, borderRadius: 2, overflow: 'hidden', '&:before': { display: 'none' } }}>
            {renderAccordionHeaderButton('calc', expandedCalc, setExpandedCalc, infoData.CALC_TITLE)}
            <AccordionDetails>
              {infoData.CALC_TEXTS?.map((line, i) => (
                <Typography key={i}>{line}</Typography>
              ))}
            </AccordionDetails>
          </Accordion>

          <Accordion expanded={expandedReturn} sx={{ mt: 2, borderRadius: 2, overflow: 'hidden', '&:before': { display: 'none' } }}>
            {renderAccordionHeaderButton('return', expandedReturn, setExpandedReturn, infoData.RETURN_TITLE)}
            <AccordionDetails>
              {infoData.RETURN_LIST?.map((section, i) => (
                <Box key={i} sx={{ mb: 2 }}>
                  <Typography sx={{ fontWeight: 'bold' }}>{section.title}</Typography>

                  {section.items?.map((item, j) => (
                    <Typography
                      key={j}
                      sx={{
                        whiteSpace: 'pre-line',
                        mt: item.startsWith('\n') ? 2 : 0
                      }}
                    >
                      {item}
                    </Typography>
                  ))}
                </Box>
              ))}
            </AccordionDetails>
          </Accordion>

          <Box sx={{ mt: 2 }}>
            <button
              style={{
                ...modalSecondaryButtonStyle(pressedBtn, 'vop', hoverBtn === 'vop'),
                width: '100%',
                background: '#1e3f44',
                color: '#fff',
                fontWeight: 600,
                borderRadius: 8,
                padding: '12px 16px'
              }}
              onMouseEnter={() => setHoverBtn('vop')}
              onMouseLeave={() => {
                setHoverBtn(null)
                setPressedBtn(null)
              }}
              onMouseDown={() => setPressedBtn('vop')}
              onMouseUp={() => setPressedBtn(null)}
              onClick={() => setOpenVopModal(true)}
            >
              {infoData.VOP_SHORT_TITLE}
            </button>
          </Box>

          <Box sx={{ height: 20 }} />
        </Box>

        <Box sx={{ borderTop: '1px solid #ddd', pt: 2, pb: 0, display: 'flex', justifyContent: 'center' }}>
          <button
            style={modalSecondaryButtonStyle(pressedBtn, 'close', hoverBtn === 'close')}
            onMouseEnter={() => setHoverBtn('close')}
            onMouseLeave={() => {
              setHoverBtn(null)
              setPressedBtn(null)
            }}
            onMouseDown={() => setPressedBtn('close')}
            onMouseUp={() => setPressedBtn(null)}
            onClick={onClose}
          >
            {t('CLOSE')}
          </button>
        </Box>
      </ModalLayout>

      <VOPModal
        open={openVopModal}
        onClose={() => setOpenVopModal(false)}
      />
    </>
  )
}